"use client";

import { useMutation } from "@tanstack/react-query";
import { transcribePublicFeedback } from "../api/transcribePublicFeedback";

export default function useTranscribePublicFeedbackMutation(token: string) {
  return useMutation({
    mutationFn: (file: File) => transcribePublicFeedback(token, file),
  });
}
